var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 11.4492C14.9439 11.4492 16.5202 9.99414 16.5202 8.19922C16.5202 6.40429 14.9439 4.94922 12.9993 4.94922C11.0548 4.94922 9.47852 6.40429 9.47852 8.19922C9.47852 9.99414 11.0548 11.4492 12.9993 11.4492Z",
    stroke: "#E7ECF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41815 19.4492H18.5819C19.819 19.4492 20.7719 18.4673 20.1942 17.4576C19.3444 15.9723 17.407 14.1992 13 14.1992C8.59304 14.1992 6.65567 15.9723 5.80587 17.4576C5.22816 18.4673 6.18107 19.4492 7.41815 19.4492Z",
    stroke: "#E7ECF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon5);
export default __webpack_public_path__ + "static/media/DashboardIcon5.7220bd39.svg";
export { ForwardRef as ReactComponent };